import axios from 'axios';
import { API_CONFIRM_DEVICE_AUTH } from '../../../endpoint';
import { SUCCESS_API_CONFIRM_DEVICE_AUTH } from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { PAGE_PATH } from '../../../../lib/constants';
import { DEVICE_AUTH_ERROR_CODE } from '../../../../lib/apiErrorCodes';

/**
 * デバイス認証確認APIを呼び出す
 *
 * @param {string} apiToken - API認証トークン
 * @param {string} deviceAuthToken - デバイス認証トークン
 * @returns
 */
const confirmDeviceAuth = (apiToken, deviceAuthToken) => dispatch => {
  consolelog('[API CALL] confirmDeviceAuth()');
  configureAxiosForJSON(apiToken);

  // APIエンドポイント
  const url = API_CONFIRM_DEVICE_AUTH;

  // キャンセルトークンの作成
  const { cancelToken, cancelTokenKey } =
    createCancelToken('confirmDeviceAuth');

  // リクエストパラメータ
  const axiosParams = {
    headers: {
      'Device-Authorization': deviceAuthToken,
    },
    cancelToken,
  };

  return axios
    .get(url, axiosParams)
    .then(res => {
      dispatch({
        type: SUCCESS_API_CONFIRM_DEVICE_AUTH,
        payload: res.data,
      });
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        if (thrown.response && thrown.response.status === 404) {
          window.location.href = `${PAGE_PATH.LOGIN_FAILURE}/${DEVICE_AUTH_ERROR_CODE.unsetAccessControlNotification}`;
        } else {
          window.location.href = `${PAGE_PATH.LOGIN_FAILURE}/${DEVICE_AUTH_ERROR_CODE.deviceAuthError}`;
        }
      }
    })
    .finally(() => delCancelToken(cancelTokenKey));
};

export default confirmDeviceAuth;
